import React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../theme';
import { CdnIcon, CdnIconNames } from '@shared/ui';

export interface TipProps {
	className?: string;
	title: string;
	variant?: 'included' | 'popular' | 'cheap';
	rightIcon?: CdnIconNames;
}

const Tip: React.FC<TipProps> = ({ className, variant = 'included', title, rightIcon }) => {
	const { Tip: theme } = useTheme('Shared');

	return (
		<span className={cn(theme.root, className, theme[variant])}>
			{title}

			{rightIcon && <CdnIcon icon={rightIcon} />}
		</span>
	);
};

export default Tip;
